// Constants
import { DEFAULT_DIRECTION, DEFAULT_LANGUAGE, DEFAULT_THEME } from 'constants/settings'

// Data: Initial state
const initialState = Object.freeze({
	direction: DEFAULT_DIRECTION,
	isLoggedIn: false,
	language: DEFAULT_LANGUAGE,
	theme: DEFAULT_THEME
})

// Export
export default initialState
